export default __webpack_public_path__ + "static/media/landing-items.66ace3c6.webp";